import container from "@/lib/di/container";
import { useState, useEffect, Key } from "react";
import { FilterBar, FilterInputTemplate, FilterInputType, handleAddressChange } from "../../components/filter/FilterBar";
import { FilterSearchPayload, DataTable } from "../../components/table/DataTable";
import { Button, Dropdown, message, Tooltip } from "antd";
import { InfoCircleOutlined, LockOutlined, MoreOutlined, SettingOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import { activeStatusPipe } from "@/core/pipes/active-status.pipe";
import AuthRepo from "@/core/repos/auth.repo";
import { DeleteButton } from "../../components/table/DeleteButton";
import { AppRoleModel, AppRoleModelFactory } from "@/core/models/app-role.model";
import { AppRoleRepo } from "@/core/repos/tables/app-role.repo";
import { DetailModal } from "./modals/DetailModal";
import { useTitleDataStore } from "@/core/stores/title-data.store";
import { PermissionModal } from "./modals/PermissionModal";

const appRoleRepo = container.get(AppRoleRepo);

export default function AccountGroupsPage() {
    const titleData = useTitleDataStore();
    const [modalData, setModalData] = useState<AppRoleModel>(AppRoleModelFactory.getEmpty())
    const [permissionData, setPermissionData] = useState<Key[]>([])
    const [filterMap, setFilterMap] = useState<Map<string, FilterSearchPayload>>(new Map())
    const [selectedRows, setSelectedRows] = useState<AppRoleModel[]>([]);
    const [isDetailModal, setDetailModal] = useState(false);
    const [isPermissionModal, setPermissionModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [filterTemplates, setFilterTemplates] = useState<FilterInputTemplate[]>([
        {
            dataIndex: "search",
            label: "Tên nhóm tài khoản",
            placeholder: "Nhập tên nhóm tài khoản",
            type: FilterInputType.text,
        },
    ])

    useEffect(() => {init()}, []);

    const init = async () => {
        titleData.setTitleActions({
            text: "Tạo Nhóm tài khoản",
            onPress: () => {
                showDetail(AppRoleModelFactory.getEmpty())
            }
        })
    }

    async function onFilterChange(map: Map<string, FilterSearchPayload>, changes: string[]) {
        await handleAddressChange(map, changes, filterTemplates, setFilterTemplates);
        setFilterMap(new Map(map));
    }

    function onRowSelect(rows: AppRoleModel[]) {
        setSelectedRows([...rows]);
    }

    const showDetail = (record: AppRoleModel) => {
        setModalData(record);
        setDetailModal(true);
    };

    const showPermissions = async (record: AppRoleModel) => {
        const roleClaims = await appRoleRepo.getAllClaims(record.name);
        const _permissions = roleClaims.map(claim => claim.id);
        setPermissionData(_permissions);
        setModalData(record);
        setPermissionModal(true);
    };

    const deleteSelected =  async () => {
        setDeleting(true);
        const result = await appRoleRepo.deleteMany(selectedRows);
        messageApi.success({
            content: `Bạn đã xoá thành công ${result.success}/${result.total} bản ghi`
        })
        setDeleting(false);
    }

    return (
    <div className="px-4 py-6">
        {contextHolder}
        <FilterBar setMap={setFilterMap} onChange={onFilterChange} templates={filterTemplates} map={filterMap} actions={[
            <div key={1} className="mt-6">
                <DeleteButton loading={deleting} length={selectedRows.length} onConfirm={deleteSelected}/>
            </div>
        ]}/>
        <div className="mt-4 border-t border-dashed border-gray-300 pt-6">
            <DataTable<AppRoleModel>
                columns={[
                    { dataIndex: 'name', name: 'Tên Nhóm quyền'},
                    { dataIndex: 'description', name: 'Mô tả'},
                    {
                        name: 'Thao tác',
                        width: 100,
                        render: (_, record) => (
                                <div className="flex flex-row px-1 items-center justify-center">
                                    <Tooltip title="Sửa bản ghi"><Button type="text" icon={<InfoCircleOutlined />} onClick={() => showDetail(record)}/></Tooltip>
                                    <Dropdown menu={{items: [
                                            {
                                                key: '1',
                                                label: <p>Chỉnh sửa quyền hạn</p>,
                                                icon: <SettingOutlined />,
                                                onClick: () => showPermissions(record)
                                            }
                                        ]}} trigger={["hover"]}>
                                            <Button type="text" icon={<MoreOutlined />}/>
                                        </Dropdown>
                                </div>
                            ),
                        fixed: "right"
                    },
                ]}
                repository={appRoleRepo}
                filterMap={filterMap}
                onSelect={onRowSelect}
            ></DataTable>
        </div>
        <DetailModal isModalOpen={isDetailModal} setIsModalOpen={setDetailModal} data={modalData}></DetailModal>
        {isPermissionModal&&<PermissionModal isModalOpen={isPermissionModal} setIsModalOpen={setPermissionModal} data={modalData} permissions={permissionData}></PermissionModal>}
    </div>)
}